/**
 * Creates a custom select box.
 *
 * @requires mustache
 * @requires templates
 */

define('libs/selectbox',['require','mustache','templates'],function(require) {

    'use strict';

    var Mustache = require('mustache'),
        templates = require('templates');

    var SETTINGS = {
        classFocus: 'focus',
        classActive: 'active',
        classHidden: 'hidden',
        boxValueSelector: '.select-box-value',
        optionSelector: '.select-box-option',
        selectorSelector: '.select-box-selection'
    };

    var SelectBox = function(element, settings) {
        if (!element || element.tagName.toLowerCase() != 'select') {
            return;
        }

        this.settings = $.extend({}, SETTINGS, settings || {});
        this.element = element;
        this.$element = $(element);
        this.value = this.element.value;

        // mark the real select as replaced.
        this.$element.addClass(this.settings.classHidden);

        // build the custom select.
        this.root = this.build(this.$element);
        this.root.on('click', this.settings.optionSelector, this.onSelect.bind(this));

        this.boxValue = $(this.settings.boxValueSelector, this.root);
        this.selector = $(this.settings.selectorSelector, this.root);

        this.selector.on('click', this.activate.bind(this));
    };

    SelectBox.prototype.build = function(element) {
        var data = {options: []};
        data.value = element.val();
        data.placeholder = element.attr('placeholder');

        for (var i = 0; i < element[0].options.length; i++) {
            data.options.push({
                option: element[0].options[i].innerHTML,
                optionValue: element[0].options[i].value,
                url: element[0].options[i].getAttribute('data-url')
            });
        }

        var box = $(Mustache.to_html(templates.selectbox, data));
        box.insertAfter(element);

        return box;
    };

    SelectBox.prototype.activate = function() {
        this.root.addClass(this.settings.classActive);
    };

    SelectBox.prototype.deactivate = function() {
        this.root.removeClass(this.settings.classActive);
    };

    SelectBox.prototype.onSelect = function(event) {
        event.preventDefault();
        this.boxValue[0].innerHTML = event.currentTarget.innerHTML;
        // set the real select value.
        this.element.value = event.currentTarget.getAttribute('data-value');
        if (this.element.value != this.value) {
            this.$element.trigger('change');
        }
        this.deactivate();
    };


    return SelectBox;
});

